<template>
  <div>
    <h2 class="contentSubTitle mb15">
      {{locale.disabled_mark}}
      <button class="btn btnWhite" @click="setDetail('new')">{{ locale.add }}</button>
    </h2>
    <ul v-if="list && list.length > 0" class="presets">
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="setDetail(item.presetId)">
        <button type="button" class="btnDel" @click.stop="deleteItem(item.presetId)"></button>
        <p class="name">{{ item.presetName }}</p>
      </li>
    </ul>
    <CompositeStatus
      v-if="detail"
      :locale="locale"
      :presetId="detail"
      @reload="getPresetList"
      @close="setDetail(null)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import CompositeStatus from './CompositeStatus'

export default {
  name: 'ShopPresetStatus',
  props: [
    'locale'
  ],
  components: {
    CompositeStatus
  },
  computed: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      list: [],
      detail: null
    }
  },
  methods: {
    async init () {
      await this.getPresetList()
    },
    async getPresetList () {
      this.$store.commit('onLoading', true)
      const getPreset = await this.$store.dispatch('shop/getShopPresetList', 'status')
      const presetList = getPreset && getPreset.message && getPreset.message.preset
      if (presetList) {
        this.list = presetList
      }
      this.$store.commit('onLoading', false)
    },
    setDetail (presetId) {
      this.detail = presetId
    },
    deleteItem (presetId) {
      this.$emit('deletePreset', 'status', presetId)
    }
  }
}
</script>
